import { render, staticRenderFns } from "./review-service-highlight.vue?vue&type=template&id=3ed1fa68"
import script from "./review-service-highlight.vue?vue&type=script&lang=js"
export * from "./review-service-highlight.vue?vue&type=script&lang=js"
import style0 from "./review-service-highlight.vue?vue&type=style&index=0&id=3ed1fa68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports